import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { FaEye } from "react-icons/fa";
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const StockManagement = () => {
    const token = localStorage.getItem('token');
    const ven_ladger_id = localStorage.getItem('ven_ladger_id');
    const navigate = useNavigate();
    const [companyDetails, setCompanyDetails] = useState({});
    const [data, setVendorData] = useState([]);
    const [VendorDataListLength, setVendorDataListLength] = useState(null);
    const [data1, setVendorDataother] = useState([]);
    const [vendorData, setVendorDataList] = useState([]);
    const [mgf, setMgf] = useState(null);
    const [VendorDataDetailsreport, setVendorDataDetailsreport] = useState([]);
    const [dataDetails, setVendorDataDetails] = useState([]);
    const [lastIndexDate, setLastIndexDate] = useState("");


    useEffect(() => {
        fetchVendor();
        fetchVendorData();
        fetchVendorDetails();
        fetchVendorDetailsreport();
    }, [token]);

    const fetchVendor = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Vendor-ladger-list/${ven_ladger_id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            const otherData = response.data.data || [];
            const otherData1 = response.data;
            console.log(otherData);
            setVendorData(otherData);
            setVendorDataother(otherData1);

        } catch (error) {
            console.error('Error fetching vendors:', error);
        }
    };
    const fetchVendorData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Vendor-payments-data-lists/${ven_ladger_id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            const otherData = response.data.data || [];
            console.warn("mithlesh babu", otherData);
            const otherData1 = response.data;
            setVendorData(otherData);
            // If you want to set the first manufacture as well
            console.warn("pppppppp", otherData[0].manufacture);
            // if (otherData.data.length > 0) {
            setMgf(otherData[0].manufacture);
            // }
            setVendorDataList(otherData1);
            setVendorDataListLength(otherData.length)
            if (otherData.length > 0) {
                const lastIndexDate = otherData[otherData.length - 1].date;
                const formattedDate = new Date(lastIndexDate).toLocaleDateString('en-GB'); // Format as DD/MM/YYYY
                setLastIndexDate(formattedDate);
            }

        } catch (error) {
            console.error('Error fetching vendors:', error);
        }
    };
    // const fetchVendorDataPay = async () => {
    //     try {
    //         const response = await axios.get(`${process.env.REACT_APP_API_URL}Vendor-Newpay-lists/${ven_ladger_id}`, {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'x-access-token': token,
    //             },
    //         });
    //         const otherData = response.data.data || [];
    //         const otherData1 = response.data;
    //         console.log(otherData);
    //         setVendorData(otherData);
    //         setVendorDataother(otherData1);
    //     } catch (error) {
    //         console.error('Error fetching vendors:', error);
    //     }
    // };
    const fetchVendorDetails = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Vender-edit/${ven_ladger_id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            const otherData = response.data.data[0] || [];
            setVendorDataDetails(otherData);
        } catch (error) {
            console.error('Error fetching vendors:', error);
        }
    };

    const fetchVendorDetailsreport = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}Vendor-report-list/${ven_ladger_id}`,
                { vendor_id: ven_ladger_id }, // Payload for the request
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });


            setVendorDataDetailsreport(response.data.data);
        } catch (error) {
            console.error('Error fetching Vendor report:', error);
        }
    };
    const handleView = (Costomer_id) => {
        localStorage.setItem('ven_costomer_id', Costomer_id);
        navigate('/vendor-ladgor-payment');
    };
    const handleViewDetails = (costomer_id) => {
        localStorage.setItem('ven_det_costomer_id', costomer_id);
        navigate('/vendor-ladgor-Details');
    };
    const handleStockDetails = (costomer_id) => {
        // localStorage.setItem('ven_det_costomer_id', costomer_id);
        navigate('/vendor-ladgor-Stock-List');
    };
    const handleMeterilsDetails = (costomer_id) => {
        // localStorage.setItem('ven_det_costomer_id', costomer_id);
        navigate('/vendor-ladgor-Meterils-List');
    };
    const handleProductManufacturDetails = (costomer_id) => {
        // localStorage.setItem('ven_det_costomer_id', costomer_id);
        navigate('/vendor-ladgor-Product-List');
    };

    useEffect(() => {
        const fetchCompanyDetails = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}Company-details-list`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });
                if (response.data.status === 1) {
                    setCompanyDetails(response.data.data[0]);
                }
            } catch (error) {
                console.error('Error fetching company details:', error);
            }
        };

        fetchCompanyDetails();
    }, [token]);

    // Calculate total, paid, and due amounts
    const VendorDataDetailsreportsum = VendorDataDetailsreport && VendorDataDetailsreport.reduce((sum, vendor) => sum + parseFloat(vendor.amount || 0), 0);
    console.warn("fgdfg", VendorDataDetailsreportsum)

    const totalAmount = data.reduce((sum, vendor) => sum + parseFloat(vendor.total_price || 0), 0);
    const totalPaid = data.reduce((sum, vendor) => sum + parseFloat(vendor.total_payments || 0), 0);
    const totalDue = totalAmount - Number(VendorDataDetailsreportsum || 0);
    console.warn("fgdfgmithlesh", totalAmount)


    // alert(totalPaid);
    return (
        <>
            <div className="App">
                <div className="card">
                    <div className="card-header">
                        <div className="d-flex">
                            <div className="address_van mx-auto">
                                <div className="text-center">
                                    <h6 className='fw-bold mb-0 fs-4 text-uppercase'>{companyDetails.company_name}</h6>
                                    <p className='addresslink'>{companyDetails.company_address},{companyDetails.state}</p>
                                    <a href="#" className='text-dark text-underlinetag'>MOB NO.- {companyDetails.mobile}</a>
                                    <p className='text-decoration-underline'>{companyDetails.city}-{companyDetails.pincode}</p>
                                </div>
                                <div className="text-center mb-30">
                                    <h5 className='fw-bold mb-0 text-red text-capitalize'>{dataDetails.vendor_name}</h5>
                                    <h6 className='fw-bold mb-0 fs-4 text-uppercase'>Vendor Ledger</h6>
                                    <p className='addresslink'> {dataDetails.address_line1} {dataDetails.address_line2}{dataDetails.city_name}-{dataDetails.pincode}</p>
                                    <a href="#" className='text-dark text-underlinetag'>MOB NO.- {dataDetails.mobile_number}</a>
                                </div>
                            </div>
                            <div><Link to='/vendermanagement' className='btn-added'>Back</Link></div>
                        </div>
                    </div>

                    <div className="card-body">
                        <table className='table table-striped hover border'>
                            <thead className='thead-dark'>

                                <tr className='mb-2'>
                                    <td className='fw-bold mb-0 text-red text-capitalize'>Vendor: {dataDetails.vendor_name}</td>
                                    <td>Payment: {totalPaid}</td>
                                    <td>Closing Balance: {totalDue + data1.totalProductAmount + data1.totalMaterialCost || 0}</td>
                                    <td></td>
                                </tr>

                                <tr>
                                    <th>Date</th>
                                    <th>Type</th>
                                    <th>Total Amount</th>
                                    <th>Paid Amount</th>

                                </tr>
                            </thead>
                            <tbody className='trcolorchange'>
                                {data1.totalProductAmount > 0 && (
                                    <tr onClick={() => handleStockDetails()}>
                                        <td>{lastIndexDate}</td>
                                        <td>Stock Product</td>
                                        {/* <td>{data1.totalProductAmount}</td> */}
                                        <td>
                                            {data1.totalProductAmount - (vendorData?.TotalLagerAmt ?? 0)}
                                        </td>
                                        <td>{vendorData.totalMgfProductAmount}</td>
                                        {/* <td></td> */}
                                    </tr>
                                )}

                                {data1.totalMaterialCost > 0 && (
                                    <tr onClick={() => handleMeterilsDetails()}>
                                        <td></td>
                                        <td>Receive Materials</td>
                                        <td>{data1.totalMaterialCost}</td>
                                        <td></td>
                                    </tr>
                                )}

                                {/* {vendorData.totalMgfProductAmount > 0 && (
                                    <tr onClick={() => handleProductManufacturDetails()}>
                                        <td></td>
                                        <td>Manufacture Product</td>
                                        <td>{vendorData.TotalLagerAmt}</td>
                                        <td>{vendorData.totalMgfProductAmount}</td>
                                    </tr>
                                )} */}
                                {/* 
                                {vendorData.totalMgfProductAmount > 0 && mgf === "Manufacture" && (
                                    <tr onClick={() => handleProductManufacturDetails()}>
                                        <td></td>
                                        <td>Manufacture Product</td>
                                        <td>{vendorData.TotalLagerAmt}</td>
                                        <td>{vendorData.totalMgfProductAmount}</td>
                                    </tr>
                        )}  */}

                                {VendorDataListLength !== null && VendorDataListLength !== undefined && VendorDataListLength > 0 && (mgf == "Manufacture") && (
                                    <tr onClick={() => handleProductManufacturDetails()}>
                                        <td>{lastIndexDate}</td>
                                        <td>Manufacture Product</td>
                                        <td>{vendorData.TotalLagerAmt}</td>
                                        <td>{vendorData.totalMgfProductAmount}</td>
                                    </tr>
                                )}



                                {/* {data && data.map((vendor, index) => (
                                    <tr key={vendor.vendor_id}>
                                        <td>{index + 1}</td>
                                        <td>{vendor.date}</td>
                                        <td>{vendor.customer_type}</td>
                                        <td>{vendor.customer_name}</td>
                                        <td>{vendor.total_price}</td>
                                        <td onClick={() => handleView(vendor.order_id)}>{vendor.total_payments}</td>
                                        <td>{vendor.total_price - vendor.total_payments}</td>
                                        <td><Button variant="secondary" onClick={() => handleViewDetails(vendor.order_id)} className="ms-2"><FaEye /></Button></td>
                                    </tr>
                                ))} */}


                            </tbody>
                        </table>


                        {/* Display Total, Paid, and Due Amount */}
                        <div className="d-flex justify-content-end ">
                            <div className="totoalamount">
                                {/* <div className='text-start mb-1'>
                                    <strong>Closing Balance : {totalDue + data1.totalProductAmount + data1.totalMaterialCost}</strong>
                                </div> */}
                                <div className='d-flex gap-2 mb-1'>
                                    <div><strong>Total Amount (Cr) :</strong></div>
                                    <div>{totalAmount + data1.totalProductAmount + data1.totalMaterialCost || 0}</div>
                                </div>
                                <div className='d-flex gap-2 mb-1'>
                                    <div><strong>Paid Amount (Dr) :</strong></div>
                                    <div>{VendorDataDetailsreportsum || 0}</div>
                                </div>
                                <div className='d-flex gap-2 mb-1'>
                                    <div><strong>Due Amount :</strong></div>
                                    <div>{totalDue + data1.totalProductAmount + data1.totalMaterialCost || 0}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default StockManagement;
